document.addEventListener("DOMContentLoaded", () => {
  const carousel = document.getElementById("vpvCarousel");
  if (!carousel) return;

  const track = carousel.querySelector(".vpv-carousel-track");
  const slides = Array.from(track.children); // real <li class="vpv-slide">
  const prevBtn = carousel.querySelector(".vpv-prev");
  const nextBtn = carousel.querySelector(".vpv-next");
  const dotsContainer = carousel.querySelector(".vpv-dots");

  const realCount = slides.length;
  if (realCount === 0) return;

  // ----- Clone first and last slide for seamless loop -----
  const firstClone = slides[0].cloneNode(true);
  const lastClone = slides[realCount - 1].cloneNode(true);

  track.appendChild(firstClone);
  track.insertBefore(lastClone, slides[0]);

  const allSlides = Array.from(track.children); // includes clones
  const totalSlides = allSlides.length;         // realCount + 2

  let index = 1; // start on first REAL slide (because 0 is lastClone)

  const getSlideWidth = () => carousel.offsetWidth;

  const setTransition = (on) => {
    track.style.transition = on ? "transform 0.35s ease" : "none";
  };

  const updatePosition = () => {
    const slideWidth = getSlideWidth();
    const offset = -index * slideWidth;
    track.style.transform = `translateX(${offset}px)`;
  };

  // Initial position
  setTransition(false);
  updatePosition();
  requestAnimationFrame(() => setTransition(true));

  // ----- Dots -----
  for (let i = 0; i < realCount; i++) {
    const dot = document.createElement("button");
    dot.setAttribute('aria-label', `Go to photo #${i+1}`)
    if (i === 0) dot.classList.add("active");
    dot.addEventListener("click", () => {
      index = i + 1; // because 0 is lastClone
      setTransition(true);
      updatePosition();
      setActiveDot();
    });
    dotsContainer.appendChild(dot);
  }

  const setActiveDot = () => {
    const dots = [...dotsContainer.children];
    dots.forEach((d, i) => {
      d.classList.toggle("active", i === index - 1); // logical slide index
    });
  };

  const resetToStart = () => {
    // moved to firstClone (visual last), snap to first real
    setTransition(false);
    index = 1;
    updatePosition();
    requestAnimationFrame(() => setTransition(true));
  };

  const resetToEnd = () => {
    // moved to lastClone (visual first), snap to last real
    setTransition(false);
    index = totalSlides - 2;
    updatePosition();
    requestAnimationFrame(() => setTransition(true));
  };

  const next = () => {
    index++;
    setTransition(true);
    updatePosition();

    // if we just moved onto the firstClone, snap back to first real
    if (index === totalSlides - 1) {
      track.addEventListener("transitionend", resetToStart, { once: true });
    }
    setActiveDot();
  };

  const prev = () => {
    index--;
    setTransition(true);
    updatePosition();

    // if we just moved onto the lastClone, snap back to last real
    if (index === 0) {
      track.addEventListener("transitionend", resetToEnd, { once: true });
    }
    setActiveDot();
  };

  prevBtn.addEventListener("click", prev);
  nextBtn.addEventListener("click", next);

  // ----- Drag / swipe like your timeline code -----
  let pressed = false;
  let startX = 0;
  const DRAG_THRESHOLD = 30; // px before we trigger a slide change

  const getPositionX = (event) =>
    event.type.includes("mouse") ? event.pageX : event.touches[0].clientX;

  const dragStart = (e) => {
    pressed = true;
    startX = getPositionX(e);
  };

  const dragMove = (e) => {
    if (!pressed) return;
    const currentX = getPositionX(e);

    if (currentX > startX + DRAG_THRESHOLD) {
      // drag right -> prev
      pressed = false;
      prev();
    } else if (currentX < startX - DRAG_THRESHOLD) {
      // drag left -> next
      pressed = false;
      next();
    }
  };

  const dragEnd = () => {
    pressed = false;
  };

  // Mouse events
  carousel.addEventListener("mousedown", (e) => {
    e.preventDefault(); // avoid selecting images
    dragStart(e);
  });
  carousel.addEventListener("mousemove", dragMove);
  carousel.addEventListener("mouseup", dragEnd);
  carousel.addEventListener("mouseleave", dragEnd);

  // Touch events
  carousel.addEventListener("touchstart", dragStart, { passive: true });
  carousel.addEventListener("touchmove", dragMove, { passive: true });
  carousel.addEventListener("touchend", dragEnd);

  // Re-align on resize
  window.addEventListener("resize", () => {
    setTransition(false);
    updatePosition();
    requestAnimationFrame(() => setTransition(true));
  });

  // ── Lightbox (PhotoSwipe v5) ────────────────────────────────────────────────
  //
  // Build the items array from real slides only — captured above, BEFORE the
  // cloneNode calls — so clones are never double-counted.
  //
  // We keep a mediaIndex → pswpIndex map because videos and models are skipped:
  //   slide 0 = image  → pswpIndex 0
  //   slide 1 = video  → skipped
  //   slide 2 = image  → pswpIndex 1
  //   slide 3 = image  → pswpIndex 2

  const pswpItems = [];
  const mediaIndexToPswp = {}; // data-lightbox-index → position in pswpItems

  slides.forEach((slide) => {
    const trigger = slide.querySelector(".vpv-lightbox-trigger");
    if (!trigger) return; // video / model slides have no trigger
    const mediaIdx = parseInt(trigger.dataset.lightboxIndex, 10);
    const src      = trigger.dataset.lightboxSrc;
    const alt      = trigger.dataset.lightboxAlt || "";
    if (!src) return;
    mediaIndexToPswp[mediaIdx] = pswpItems.length;
    pswpItems.push({ src, alt, width: 2048, height: 2048 });
  });

  if (pswpItems.length === 0) return; // no lightboxable slides, bail

  // Delegated listener on the track — works for both real slides and clones
  // since clones are faithful deep copies of the original DOM (data-* intact).
  track.addEventListener("click", async (e) => {
    const trigger = e.target.closest(".vpv-lightbox-trigger");
    if (!trigger) return;

    const mediaIdx = parseInt(trigger.dataset.lightboxIndex, 10);
    const pswpIdx  = mediaIndexToPswp[mediaIdx];
    if (pswpIdx === undefined) return;

    const PhotoSwipe = await loadPswp();
    if (!PhotoSwipe) return;

    const pswp = new PhotoSwipe({
      dataSource:          pswpItems,
      index:               pswpIdx,
      bgOpacity:           0.92,
      zoom:                true,
      maxZoomLevel:        4,
      initialZoomLevel:    "fit",
      secondaryZoomLevel:  2,
      wheelToZoom:         true,
      pinchToClose:        true,
      closeOnVerticalDrag: true,
      padding:             { top: 20, bottom: 20, left: 20, right: 20 },
    });

    pswp.init();
  });

  // Keyboard: Enter / Space on focused trigger
  track.addEventListener("keydown", async (e) => {
    if (e.key !== "Enter" && e.key !== " ") return;
    const trigger = e.target.closest(".vpv-lightbox-trigger");
    if (!trigger) return;
    e.preventDefault();
    trigger.click(); // reuse the click handler above
  });

  /**
   * Lazy-load PhotoSwipe v5 as an ES module — zero global pollution,
   * no conflict with any v4 PhotoSwipe instance the theme may load separately.
   * Promise is cached so the network hit only happens once per page.
   */
  function loadPswp() {
    if (!document.getElementById("vpv-pswp-css")) {
      const link = Object.assign(document.createElement("link"), {
        id:   "vpv-pswp-css",
        rel:  "stylesheet",
        href: "https://cdn.jsdelivr.net/npm/photoswipe@5/dist/photoswipe.css",
      });
      document.head.appendChild(link);
    }

    if (!window.__vpvPswpPromise) {
      window.__vpvPswpPromise = import(
        "https://cdn.jsdelivr.net/npm/photoswipe@5/dist/photoswipe.esm.min.js"
      )
        .then((m) => m.default)
        .catch((err) => {
          console.error("[vpv-pdp-carousel] PhotoSwipe load failed:", err);
          window.__vpvPswpPromise = null;
          return null;
        });
    }

    return window.__vpvPswpPromise;
  }
});
